import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const CaseStudiesCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-blue-700">
      <div className="max-w-4xl mx-auto text-center text-white space-y-6">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Your growth story could be next.
        </h2>
        <p className="text-blue-100 text-lg max-w-2xl mx-auto leading-relaxed">
          Whether you're scaling an app, launching a campaign or building a
          full-funnel acquisition engine — let's talk about what's possible.
        </p>
        <div className="pt-4">
          <Button
            data-testid="case-studies-cta-btn"
            onClick={() => {
              navigate('/contact');
              window.scrollTo(0, 0);
            }}
            className="bg-white text-blue-700 hover:bg-blue-50 font-semibold px-8 py-6 text-base rounded-full group"
          >
            Book a free growth session
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesCTA;
